import { motion } from 'framer-motion'
import styled from 'styled-components'

import { button } from 'components/Editor/styled/Button'

const IncompleteElementButton = styled(motion.button)`
  ${button}

  display: flex;
  height: 36px;
  width: 100%;
  flex-shrink: 0;
  align-items: center;
  border-radius: var(--brand-borderRadius);
  font-weight: 500;
  font-size: 14px;
  color: var(--brand-primaryTextColor);
  background: none;
  border: none;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: var(--brand-hoverColor);
  }
`

export default IncompleteElementButton
